module.exports = __webpack_public_path__ + "type_graphics.ee80c840e6e2838a124c";


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/assets/img/admin/type_graphics.jpg
// module id = ../../../../../src/assets/img/admin/type_graphics.jpg
// module chunks = monitor-agents.module